"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BolaBasic = void 0;
var abr_types_1 = require("../../abr-types");
var defaultConfig = {
    minimumBuffer: 10, // This is the min buffer in seconds
    minimumBufferPerBitRateLevel: 2, // The min buffer for bitrate level in seconds. e.g. If there are 5 bitrates (minimumBuffer: 10) + 5 * (minimumBufferPerBitRateLevel: 2) = 20s
    bufferTimeDefault: 15, // This is to be considered the stable target buffer in seconds
};
var BolaBasic = /** @class */ (function () {
    function BolaBasic(logger, bufferAssessment, bolaBasicConfig) {
        this.bufferAssessment = bufferAssessment;
        this.tracksAscending = [];
        this.shouldWaitForBandwidth = false;
        this.logger = logger.withContext('Bola Basic');
        this.logger.verbose('Received config: ', bolaBasicConfig);
        this.bolaBasicConfig = __assign(__assign({}, defaultConfig), bolaBasicConfig);
        this.logger.info('Using config: ', this.bolaBasicConfig);
    }
    Object.defineProperty(BolaBasic.prototype, "name", {
        get: function () {
            return abr_types_1.AbrType.BOLA_BASIC;
        },
        enumerable: false,
        configurable: true
    });
    BolaBasic.prototype.getRecommendedTracks = function () {
        if (!this.tracksAscending.length) {
            return null;
        }
        return this.chooseTracks();
    };
    BolaBasic.prototype.setTracksAscending = function (tracksAscending) {
        this.tracksAscending = tracksAscending;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    BolaBasic.prototype.notifiedPlaybackRateChange = function (rate) {
        // No-op
    };
    /**
     * Taken from the original implementation in dash.js
     * repository: https://github.com/Dash-Industry-Forum/dash.js/blob/da4a7b5b2c815506c4aba2b3f727e497a721567a/src/streaming/rules/abr/BolaRule.js#L91
     * paper: https://arxiv.org/pdf/1601.06748.pdf VI(DEPLOYMENT) A (The DASH Reference Player)
     */
    BolaBasic.prototype.calculateBolaParameters = function (bufferTimeDefault, bitrates, utilities) {
        var highestUtilityIndex = utilities.reduce(function (highestIndex, u, uIndex) { return (u > utilities[highestIndex] ? uIndex : highestIndex); }, 0);
        if (highestUtilityIndex === 0) {
            // if highestUtilityIndex === 0, then always use lowest bitrate
            return null;
        }
        var bufferTime = Math.max(bufferTimeDefault, this.bolaBasicConfig.minimumBuffer + this.bolaBasicConfig.minimumBufferPerBitRateLevel * bitrates.length);
        // TODO: Investigate if following can be better if utilities are not the default Math.log utilities.
        // If using Math.log utilities, we can choose Vp and gp to always prefer bitrates[0] at minimumBufferS and bitrates[max] at bufferTarget.
        // (Vp * (utility + gp) - bufferLevel) / bitrate has the maxima described when:
        // Vp * (utilities[0] + gp - 1) === minimumBufferS and Vp * (utilities[max] + gp - 1) === bufferTarget
        // giving:
        var gp = (utilities[highestUtilityIndex] - 1) / (bufferTime / this.bolaBasicConfig.minimumBuffer - 1);
        var Vp = this.bolaBasicConfig.minimumBuffer / gp;
        // note that expressions for gp and Vp assume utilities[0] === 1, which is true because of normalization
        return { gp: gp, Vp: Vp };
    };
    // The core idea of BOLA.
    BolaBasic.prototype.getQualityFromBufferLevel = function (_a) {
        var gp = _a.gp, Vp = _a.Vp, bitrates = _a.bitrates, bufferLevel = _a.bufferLevel, utilities = _a.utilities;
        var numberOfBitrates = bitrates.length;
        var quality = NaN;
        var score = NaN;
        for (var i = 0; i < numberOfBitrates; ++i) {
            var s = (Vp * (utilities[i] + gp) - bufferLevel) / bitrates[i];
            if (isNaN(score) || s >= score) {
                score = s;
                quality = i;
            }
        }
        return quality;
    };
    BolaBasic.prototype.chooseTracks = function () {
        var bufferLevel = this.bufferAssessment.getStabilisedBufferAhead();
        var bitrates = this.tracksAscending.map(function (track) { return track.combinedBandwidth; });
        var utilities = bitrates
            .map(function (b) { return Math.log(b); }) // no need to worry about offset, utilities will be offset (uniformly) anyway later
            .map(function (utility, _, array) { return utility - array[0] + 1; }); // normalise
        var params = this.calculateBolaParameters(this.bolaBasicConfig.bufferTimeDefault, bitrates, utilities);
        if (!params) {
            return this.tracksAscending[0];
        }
        var suggestedTrackIndex = this.getQualityFromBufferLevel({
            bitrates: bitrates,
            utilities: utilities,
            bufferLevel: bufferLevel,
            gp: params.gp,
            Vp: params.Vp,
        });
        return this.tracksAscending[suggestedTrackIndex] || this.tracksAscending[0];
    };
    BolaBasic.prototype.destroy = function () {
        // noop
    };
    return BolaBasic;
}());
exports.BolaBasic = BolaBasic;
